export const data = {
  facebookUrl: 'https://www.facebook.com/profile.php?id=61557995012089&mibextid=ZbWKwL',
  phone: '(833)218-92-27',
  whatsapp: '(833)164-30-86',
  contactName: 'Atención a Clientes',
  contactEmail: 'ventas@cimc.com.mx',
  address: 'Violeta #102, Col. Flores, Tampico Tamaulipas, México',
  products: 'https://scripts.nyc3.cdn.digitaloceanspaces.com/Catalogo%20CIMC%202023%20-1.pdf',
  name: 'Contraincendio Marítimo de Campeche'
}